// Auth Store for persistent authentication
const AUTH_STORAGE_KEY = 'descope_auth_data';
class AuthStore {
    constructor() {
        this.storage = typeof window !== 'undefined' ? window.localStorage : {
            getItem: () => null,
            setItem: () => { },
            removeItem: () => { },
            clear: () => { },
            length: 0,
            key: () => null
        };
    }
    // Save authentication data
    saveAuthData(data) {
        try {
            const authData = {
                ...data,
                lastLogin: Date.now()
            };
            this.storage.setItem(AUTH_STORAGE_KEY, JSON.stringify(authData));
            console.log('🔐 Auth data saved to persistent storage');
        }
        catch (error) {
            console.error('Failed to save auth data:', error);
        }
    }
    // Get authentication data
    getAuthData() {
        try {
            const data = this.storage.getItem(AUTH_STORAGE_KEY);
            if (data) {
                const parsed = JSON.parse(data);
                console.log('🔐 Auth data retrieved from persistent storage');
                return parsed;
            }
        }
        catch (error) {
            console.error('Failed to retrieve auth data:', error);
        }
        return null;
    }
    // Clear authentication data
    clearAuthData() {
        try {
            this.storage.removeItem(AUTH_STORAGE_KEY);
            console.log('🔐 Auth data cleared from persistent storage');
        }
        catch (error) {
            console.error('Failed to clear auth data:', error);
        }
    }
    // Check if auth data exists and is not expired
    hasValidAuthData() {
        const data = this.getAuthData();
        if (!data || !data.lastLogin) {
            return false;
        }
        // Check if auth data is older than 30 days (optional expiration check)
        const thirtyDaysInMs = 30 * 24 * 60 * 60 * 1000;
        const isExpired = Date.now() - data.lastLogin > thirtyDaysInMs;
        if (isExpired) {
            console.log('🔐 Auth data expired, clearing...');
            this.clearAuthData();
            return false;
        }
        return true;
    }
    // Get refresh token
    getRefreshToken() {
        const data = this.getAuthData();
        return data?.refreshToken || null;
    }
    // Get session token
    getSessionToken() {
        const data = this.getAuthData();
        return data?.sessionToken || null;
    }
    // Get user data
    getUser() {
        const data = this.getAuthData();
        return data?.user || null;
    }
}
// Create singleton instance
export const authStore = new AuthStore();
